import 'rc-slider/assets/index.css'
import React from 'react'
import {render} from 'react-dom'
import {forEach} from 'lodash'

import PlayerIFrame from './player/components/PlayerIFrame'
import {ExternalController} from 'player/components/PlayerIFrame/types'

const InitSuccessMessage = () => ({type: 'INIT_SUCCESS'})
const PlayerReadyMessage = (duration: number) => ({type: 'PLAYER_READY', duration})
const ReportIsPowtoonEndMessage = (isPowtoonEnd: boolean) => ({type: 'REPORT_IS_POWTOON_END', isPowtoonEnd})
const sourceWindows: any[] = []
const postMessageToAll = (message: any) => forEach(sourceWindows, source => source.postMessage(message, '*'))

let playerController: ExternalController
function onPlayerReady(_playerController: ExternalController) {
  playerController = _playerController
  const duration = playerController.getTotalDuration()
  postMessageToAll(PlayerReadyMessage(duration))
}

let isEnd: boolean = false
function reportIsEnd(isPowtoonEnd: boolean) {
  if (isEnd === isPowtoonEnd) {
    return
  }

  isEnd = isPowtoonEnd
  postMessageToAll(ReportIsPowtoonEndMessage(isPowtoonEnd))
}

const _postResponseMessage = (sourceEvent: MessageEvent, response: any) => {
  const {source, data} = sourceEvent

  if (source) {
    (source as Window).postMessage({...data, response}, '*')
  }
}

window.onmessage = (e: MessageEvent) => {
  const {data, source} = e

  const sendResponseMessage = (res?: any) => _postResponseMessage(e, res)
  if (!playerController) {
    if (data.type === 'INIT') {
      sourceWindows.push(source)
      if (source) {
        (source as Window).postMessage(InitSuccessMessage(), '*')
      }
    }
  } else {
    switch (data.type) {
      case 'INIT':
        const duration = playerController.getTotalDuration()
        ; (source as Window).postMessage(PlayerReadyMessage(duration), '*')
        break
      case 'PLAY':
        playerController.play()
        sendResponseMessage()
        break
      case 'PAUSE':
        playerController.pause()
        sendResponseMessage()
        break
      case 'JUMP_TO_START':
        playerController.jumpToStart()
        sendResponseMessage()
        break
      case 'HIDE_CONTROLS':
        playerController.setShowControls(false)
        break
      case 'SHOW_CONTROLS':
        playerController.setShowControls(true)
        break
      default:
        break
    }
  }
}

function onTimeChange() {
  reportIsEnd(false)
}
function onEnd() {
  reportIsEnd(true)
}

const iframe = render(
  <PlayerIFrame onPlayerReady={onPlayerReady} onTimeChange={onTimeChange} onEnd={onEnd} />,
  document.getElementById('mainPlayer')
)

export default iframe
